import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActivityIndicatorService {
    // tslint:disable-next-line:variable-name
    private _isBusy: BehaviorSubject<boolean>;
    public IsBusy: Observable<boolean>;

    constructor() {
        this._isBusy = new BehaviorSubject<boolean>(false);
        this.IsBusy = this._isBusy.asObservable();
    }

    public ShowLoading(value: boolean) {
        this._isBusy.next(value);
    }

}
